import React, { useEffect, useMemo, useRef } from "react";
import { observer } from "mobx-react";
import { CollectiveManagementSocietyViewStore } from "../../store";
import { CollectiveManagementSocietyView } from "./CollectiveManagementSocietyView";
import { CollectiveManagementSocietyUpdateStore } from "../../store";
import { CollectiveManagementSocietyUpdate } from "../update/CollectiveManagementSocietyUpdate";
import { useRootStore } from "../../../../store/contexts/RootStoreContext";
import { Box, CircularProgress } from "@mui/material";

export type CollectiveManagementSocietyDrawerContentProps = {
  entityId: string;
  mode?: "view" | "update";
};

export const CollectiveManagementSocietyDrawerContent: React.FC<CollectiveManagementSocietyDrawerContentProps> =
  observer(({ entityId, mode = "view" }) => {
    const rootStore = useRootStore();
    const viewInitializedRef = useRef<string | null>(null);
    const updateInitializedRef = useRef<string | null>(null);

    const viewStore = useMemo(() => {
      const s = new CollectiveManagementSocietyViewStore(rootStore);
      s.isDrawerMode = true;
      return s;
    }, [rootStore]);

    useEffect(() => {
      if (
        mode === "view" &&
        entityId &&
        viewInitializedRef.current !== entityId
      ) {
        viewInitializedRef.current = entityId;
        viewStore.initialize({ id: entityId });
      }
    }, [entityId, mode, viewStore]);

    const updateStore = useMemo(() => {
      const s = new CollectiveManagementSocietyUpdateStore(rootStore);
      s.isDrawerMode = true;
      return s;
    }, [rootStore]);

    useEffect(() => {
      if (
        mode === "update" &&
        entityId &&
        updateInitializedRef.current !== entityId
      ) {
        updateInitializedRef.current = entityId;
        updateStore.initialize({ id: entityId });
      }
    }, [entityId, mode, updateStore]);

    if (mode === "update") {
      if (
        updateStore.status === "processing" ||
        updateStore.status === "uninitialized"
      ) {
        return (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 200,
            }}
          >
            <CircularProgress />
          </Box>
        );
      }
      return (
        <CollectiveManagementSocietyUpdate
          collectiveManagementSocietyUpdateStore={updateStore}
        />
      );
    }

    if (
      viewStore.status === "processing" ||
      viewStore.status === "uninitialized"
    ) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 200,
          }}
        >
          <CircularProgress />
        </Box>
      );
    }

    return (
      <CollectiveManagementSocietyView
        collectiveManagementSocietyViewStore={viewStore}
      />
    );
  });
